import React from 'react'
import Style from 'style-it'

class Sidebar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { height, topOffset, activeItemId, items, methods } = this.props

        return (
            <aside className="sidebar" style={{ height: height, top: topOffset }}>
                <nav className="sidebar-nav">
                    <ul className="list">
                        {items.map((item, index) => {
                            return (
                                <li key={index}>
                                    <Style>
                                        {`
                                                      .list-item:hover > .text > p, .list-item.is-active > .text > p {
                                                         ${
                                                             item.payload.color
                                                                 ? `color: ${item.payload.color} !important;`
                                                                 : ''
                                                         }
                                                      }
                                                      .list-item .icon {
                                                        background-image: url(${item.payload.iconUrl})
                                                      }
                                                      .list-item.is-active .icon, .list-item:hover .icon {
                                                        background-image: url(${item.payload.selectedIconUrl})
                                                      }
                                                      ${
                                                          item.disabled
                                                              ? `
                                                              .list-item .icon {
                                                                background-image: url(${item.payload.icon})
                                                              }
                                                          `
                                                              : null
                                                      }
                                                    `}
                                        <div
                                            className={`list-item${
                                                item.payload.customId === activeItemId ? ' is-active' : ''
                                            }${item.disabled ? ' is-disabled' : ''}`}
                                            onClick={() => methods.onClickItem(item.payload.customId)}
                                        >
                                            {item.payload.id || item.disabled ? <div className="icon"></div> : null}

                                            <div className="text">
                                                <p>{item.label}</p>
                                            </div>
                                        </div>
                                    </Style>
                                </li>
                            )
                        })}
                    </ul>
                </nav>
            </aside>
        )
    }
}

export default Sidebar
